import { useMemo } from 'react';
import { DetailField, DetailViewModal } from '../../../shell/DetailViewModal.js';
import { formatDate } from '../../../lib/format.js';
import { useEmployeeDirectory } from '../../employees/api.js';
import { formatEmployeeOption } from '../../employees/components/EmployeeSelect.js';
import type { EmployeeFileNote } from '@shared/types';
import { FileNoteAttachments } from './EmployeeFileNotesSection.js';

export function FileNoteViewModal({
  open,
  onClose,
  note,
}: {
  open: boolean;
  onClose: () => void;
  note: EmployeeFileNote | null;
}) {
  const { data: directory } = useEmployeeDirectory();
  const employeeLabels = useMemo(() => {
    if (!note) return new Map<string, string>();
    const map = new Map<string, string>();
    for (const e of directory?.items ?? []) {
      map.set(e.id, formatEmployeeOption(e));
    }
    return map;
  }, [note, directory?.items]);

  if (!note) return null;

  return (
    <DetailViewModal open={open} onClose={onClose} title={note.title}>
      <DetailField label="Date">{formatDate(note.date)}</DetailField>
      <DetailField label="On personnel file for">
        <ul className="list-inside list-disc space-y-1">
          {note.employeeIds.map((id) => (
            <li key={id}>{employeeLabels.get(id) ?? 'Employee'}</li>
          ))}
        </ul>
      </DetailField>
      <DetailField label="Details">{note.details}</DetailField>
      {note.attachments.length > 0 && (
        <DetailField label="Attachments">
          <FileNoteAttachments noteId={note.id} attachments={note.attachments} />
        </DetailField>
      )}
    </DetailViewModal>
  );
}
